import { Loader } from 'lucide-react'
import { Navigate } from 'react-router'
import useAuth from 'src/enviroment/hooks/useAuth'
import { ROUTES } from 'src/types/routes'

const ProtectedRoute = ({ children, allowedRoles = [] }: { children: React.ReactNode; allowedRoles?: string[] }) => {
  const { isAuthenticated, userRole, isSuperAdmin, isLoading, hasTenant, isPickingTenant } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.SIGN_IN} replace state={{ from: window.location.pathname }} />
  }

  if (isLoading || isPickingTenant) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Loader className="h-6 w-6 animate-spin text-gray-400" />
      </div>
    )
  }

  // Onboarding flow disabled — sign-up completes onboarding, so no step redirect
  // if (user && !user.isOnboardingFinished && user.step !== ONBOARDING_STEP.ONBOARDING_DONE) {
  //   const onboardingRoute = STEP_ROUTES[user.step]
  //   if (onboardingRoute) {
  //     return <Navigate to={onboardingRoute} replace />
  //   }
  // }

  if (!hasTenant && window.location.pathname !== ROUTES.PROFILE) {
    return <Navigate to={ROUTES.PROFILE} replace />
  }

  if (allowedRoles.length > 0 && !isSuperAdmin && !allowedRoles.includes(userRole)) {
    return <Navigate to={ROUTES.HOME_ALT} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
